// Sketch iso axes → three.js axes so the default camera matches the drawing.
const AXES = { X: [0, 0, -1], Y: [0, 1, 0], Z: [1, 0, 0] };
const AXIS_RE = /^[+-][XYZ]$/;

const norm = (a) => String(a || "").trim().toUpperCase();
export const vec = (ax, k) => AXES[ax.slice(-1)].map((v) => v * (ax.startsWith("-") ? -1 : 1) * k);

export const validSegs = (segments) => (segments || []).filter((s) => AXIS_RE.test(norm(s?.axis)));

// Direction of a run in mm; sloped runs mix the main axis with a perpendicular offset.
function runVector(s, len) {
  const ax = norm(s.axis);
  const off = norm(s.offset_axis);
  const o = Number(s.offset_mm);
  if (!AXIS_RE.test(off) || off.slice(-1) === ax.slice(-1) || !(o > 0)) return vec(ax, len);
  const along = o < len ? Math.sqrt(len * len - o * o) : len * Math.SQRT1_2;
  const across = o < len ? o : len * Math.SQRT1_2;
  const a = vec(ax, along);
  const b = vec(off, across);
  return a.map((v, i) => v + b[i]);
}

export function buildPoints(segments) {
  const segs = validSegs(segments);
  if (!segs.length) return null;
  const known = segs.map((s) => Number(s.length_mm)).filter((n) => n > 0);
  const fallback = known.length ? known.reduce((a, b) => a + b, 0) / known.length : 500;
  const pts = [[0, 0, 0]];
  segs.forEach((s) => {
    const len = (Number(s.length_mm) > 0 ? Number(s.length_mm) : fallback) / 1000;
    const p = pts[pts.length - 1];
    const d = runVector(s, len);
    pts.push(p.map((v, i) => v + d[i]));
  });
  return pts;
}

// AI fittings use 1-based segment numbers of the raw list; map to valid-run indices.
export function mapFittings(segments, fittings) {
  const idx = [];
  (segments || []).forEach((s, i) => { if (AXIS_RE.test(norm(s?.axis))) idx[i] = idx.filter((v) => v !== undefined).length; });
  return (fittings || []).map((f) => ({
    type: f.type, seg: idx[Number(f.segment) - 1], pos: f.position_mm != null ? Number(f.position_mm) / 1000 : null,
    branchAxis: AXIS_RE.test(norm(f.branch_axis)) ? norm(f.branch_axis) : "-Y", branchLen: Number(f.branch_mm) > 0 ? Number(f.branch_mm) / 1000 : null,
  })).filter((f) => f.seg !== undefined && ["valve", "flange", "reducer", "tee"].includes(f.type));
}
